module.exports = __webpack_public_path__ + "static/media/OrderIcon.c14ff1a0.svg";